/**
 * Created by lakshan on 6/6/17.
 */
(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name messageAdmin.service:MessageAdminService
   *
   * @description
   *
   */
  angular.module('flightCargo').service('FlightCargoService', FlightCargoService);

  function FlightCargoService(RemoteService, FlightCargoFactory) {

    var self = this;

    self.searchFlightCargoList = function(searchParam, successFn, errorFn) {
		var requestParam = FlightCargoFactory.searchFlightCargoRQ(searchParam);
		RemoteService.searchFlightCargo.call(this, requestParam).then(
			function (response) {
				angular.forEach(response.flightCargoDTOs, function(flight){
					flight.orgCargoWeight = parseFloat(flight.cargoWeight);
				});
				successFn(response);
			},
			function (error) {
				errorFn(error);
			}
		);
	}

    self.updateFlightCargoList = function(requestParam, successFn, errorFn) {
    	var processedRequestParam = FlightCargoFactory.updateFlightCargoRQ(requestParam);
		RemoteService.updateFlightCargo.call(this, processedRequestParam).then(
			function (response) {
				successFn(response);
			},
			function (error) {
				errorFn(error);
			}
		);
	}

    self.appendToGridFlightList = function (existingGridFlightData, newGridFlightData) {
		angular.forEach(newGridFlightData.flightCargoDTOs, function (flightObj) {
			var foundFlightIndex = _.findIndex(existingGridFlightData.flightCargoDTOs, {flightLegId: flightObj.flightLegId})
			if (foundFlightIndex >= 0) {
				existingGridFlightData.flightCargoDTOs.splice(foundFlightIndex, 1, flightObj);
			} else {
				existingGridFlightData.flightCargoDTOs.push(flightObj);
			}
		});
	};


    self.getSearchCargoWeight = function () {
      var listLocalSearchWithin = [
        {
          value: 'B',
          name: "all",
          text: "ALL",
          selected: true
        },
        {
          value: 'Y',
          name: "include",
          text: "INCLUDE",
          selected: false
        },
        {
          value: 'N',
          name: "exclude",
          text: "EXCLUDE",
          selected: false
        }
      ];
      return listLocalSearchWithin;
    };

  }
})();
